export default "* Kendetegn\n* Form\n* kamuflage";